<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Recover your password</h4>
                  <p>
                    Please enter your email address and we'll send you
                    instructions on how to reset your password.
                  </p>
                </div>


                <vs-input v-validate="'required|email'" data-vv-validate-on="blur" name="email" icon-no-border
                  icon="icon icon-user" icon-pack="feather" label-placeholder="Email" v-model="email"
                  class="w-full mb-8" />
                <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first("email") }}</span>

                <template>
                  <vue-recaptcha @verify="markRecaptchaAsVerified" :sitekey="sitekey"></vue-recaptcha>
                </template>
                <span class="text-danger text-sm">{{ pleaseTickRecaptchaMessage }}</span>


                <div class="mt-8">
                  <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                  <vs-button :disabled="!validateForm" @click="checkIfRecaptchaVerified"
                    class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0">Recover Password</vs-button>

                </div>


              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import config from "../../config";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      sitekey: config.getConfig().recaptcha,
      email: "",
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: ''
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != null;
    }
  },
  methods: {
    markRecaptchaAsVerified() {
      this.pleaseTickRecaptchaMessage = '';
      this.recaptchaVerified = true;
    },
    checkIfRecaptchaVerified() {
      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Please tick recaptcha.';
        return true; // prevent form from submitting
      }
      this.recoverPassword()
    },
    recoverPassword() {
      this.$vs.loading();
      this.$store
        .dispatch("userManagement/recoverPassword", this.email)
        .then(res => {
          const data = (res && res.data) ? res.data : (res || {});

          if (data && data.status === "success") {
            this.$vs.notify({
              color: "success",
              title: "Forgot Password",
              text: data.message
            });

            setTimeout(() => {
              this.$vs.loading.close();
              this.$router.replace("/login");
            }, 1000);
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Forgot Password",
              text: (data && data.message) || "Request could not be processed."
            });
            this.$vs.loading.close();
          }

          this.email = "";
        })
        .catch(err => {
          console.log(err);
          this.$vs.loading.close();

          const is429 = (err && err.response && err.response.status === 429) || (err && err.message && err.message.includes("429"));
          const errorMessage = is429
            ? "Too many requests — please wait 60 minutes before trying again."
            : (err && err.response && err.response.data && err.response.data.message) || (err && err.message) || "Request could not be processed.";

          this.$vs.notify({
            color: "danger",
            title: "Forgot Password",
            text: errorMessage
          });
        });
    }
  },
  created() {
    // Register Module UserManagement Module
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
  }
};
</script>
